export enum DateFormatEnum {
  BASIC = 'basic',
  SHORT = 'short',
  DATE_TIME_SEC = 'dateTimeSec',
  DATE_TIME_MIN = 'dateTimeMin',
  DATE_TIME_TZ = 'dateTimeTz'
}
